export const themes = {
    light: {
        theme: 'light',
        backgroundPrimary:  '#f5f5f5',
        backgroundSecudary: 'hsl(197, 100%, 60%)',
        textColor: 'hsl(200, 15%, 8%)',
        boxShadow: '2px 2px 2px hsl(0, 0%, 45%)',
        colorButton: 'hsl(197, 100%, 60%)',
        colorCard: 'green',
        backgroundContent: 'hsl(197, 100%, 60%)'
    },

    dark: {
        theme: 'dark',
        backgroundPrimary:  'hsl(207, 26%, 17%)',
        backgroundSecudary: 'hsl(209, 23%, 22%)',
        textColor: 'hsl(0, 0%, 100%)',
        boxShadow: '2px 2px 2px hsl(0, 0%, 10%)',
        colorButton: 'rgb(230, 224, 233)',
        colorCard: 'green',
        backgroundContent: '#f5f5f5'
    },

    pokemonBackground: {
        normal: '#b7b6a3',
        fighting: '#c56d5b',
        flying: '#9aa7fa',
        poison: '#b76da3',
        ground: '#e2c469',
        rock: '#c5b678',
        bug: '#b7c43e',
        ghost: '#7d7cc0',
        steel: '#b7b6c0',
        fire: '#ff5f3e',
        water: '#51a7fa',
        grass: '#8bd369',
        electric: '#ffd34c',
        psychic: '#ff6da3',
        ice: '#7dd3fa',
        dragon: '#8b7ceb',
        dark: '#8b6d5b',
        fairy: '#f1a7ec'
    }   
}